
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Cabserviceinthane() {



    const cardData =
    {
        keyword: 'Cab Service in Thane ',
        heading: 'Vedant Travels: Cab Service in Thane',
        headingDescription: 'Vedant Travels offers reliable and affordable cab services in Thane, ensuring a comfortable and hassle-free travel experience. Whether you need a local city ride, an airport transfer, or an outstation trip, our well-maintained fleet of sedans, SUVs, and luxury cars caters to all travel needs. With professional drivers, 24/7 availability, and competitive fares, Vedant Travels makes your travel in and around Thane convenient and stress-free.',

        top: 'Top Places to Visit in Thane with Vedant Travels',

"topPlaces": [
    {
        "title": "Upvan Lake",
        "description": "One of the most picturesque locations in Thane, Upvan Lake is a popular spot for relaxation and evening walks. Surrounded by lush greenery and the Yeoor Hills, it is a great place for boating and photography. The Sanskruti Arts Festival held here attracts art lovers from all over Mumbai."
    },
    {
        "title": "Yeoor Hills",
        "description": "A perfect getaway for nature lovers and trekkers, Yeoor Hills is often called the 'lungs of Thane.' Located in the Sanjay Gandhi National Park, it offers scenic trails, waterfalls, and a peaceful retreat away from city life. The area is also home to a variety of birds and wildlife, making it a great spot for nature enthusiasts."
    },
    {
        "title": "Tikuji-Ni-Wadi",
        "description": "One of Thane’s most famous amusement and water parks, Tikuji-Ni-Wadi is an ideal destination for families and kids. It features thrilling rides, wave pools, and adventure activities, along with a dedicated Lord Shiva temple that attracts devotees during Mahashivratri."
    },
    {
        "title": "Suraj Water Park",
        "description": "A must-visit for water lovers, Suraj Water Park is known for its exciting water slides, artificial waterfalls, and wave pools. It’s a perfect destination for a fun-filled family outing, offering a refreshing escape from the heat."
    },
    {
        "title": "Kelva Beach",
        "description": "Located a short drive from Thane, Kelva Beach is a beautiful and less crowded coastal destination. It’s known for its golden sands, scenic sunset views, and water sports activities. Visitors can also explore the Kelva Fort and Shitla Devi Temple, adding a historical and spiritual touch to the trip."
    },
    {
        "title": "Kachrali Lake",
        "description": "A serene and well-maintained lake in the heart of Thane, Kachrali Lake is perfect for an evening stroll or a morning jog. The boating facility and beautiful surroundings make it a great place to unwind."
    },
    {
        "title": "Ghodbunder Fort",
        "description": "A hidden gem in Thane, Ghodbunder Fort is a historic structure built by the Portuguese in the 16th century. It offers panoramic views of the Vasai Creek and the surrounding area, making it a great spot for history buffs and photography enthusiasts."
    },
    {
        "title": "Ovalekar Wadi Butterfly Garden",
        "description": "A paradise for nature lovers, this butterfly garden is home to over 130 species of butterflies. Located near Ghodbunder Road, it provides a unique opportunity to observe butterflies in their natural habitat and learn about their life cycle."
    },
    {
        "title": "Masunda Lake (Talao Pali)",
        "description": "One of Thane’s most iconic lakes, Masunda Lake (popularly known as Talao Pali) is a popular spot for boating and leisure walks. The Gadkari Rangayatan theater nearby hosts cultural events and plays, making it a hub for entertainment."
    },
    {
        "title": "St. John the Baptist Church",
        "description": "One of the oldest churches in Thane, St. John the Baptist Church is known for its beautiful Portuguese-style architecture and peaceful ambiance. It stands as a historical landmark, offering a glimpse into Thane’s colonial past."
    }
],

"services": [
    {
      "name": "Cab Service in Thane by Vedant Travels",
      "description": "Looking for a reliable and comfortable cab service in Thane? Vedant Travels offers high-quality taxi services, ensuring that your journey is smooth and hassle-free. Whether it's for a quick trip or a longer journey, we provide professional drivers and well-maintained vehicles for all your transportation needs."
    },
    {
      "name": "Thane Taxi Service",
      "description": "Traveling in and around Thane? Vedant Travels provides efficient and affordable taxi services throughout Thane. Whether you're commuting for work, leisure, or any other purpose, our fleet of vehicles ensures a comfortable and reliable ride."
    },
    {
      "name": "Thane Car Hire",
      "description": "Need a car to hire in Thane? Vedant Travels offers car hire services that are flexible and convenient, perfect for your local or long-distance travel. Choose from a variety of vehicles, including sedans and SUVs, for a comfortable journey at your convenience."
    },
    {
      "name": "Thane to Mumbai Cab",
      "description": "Traveling from Thane to Mumbai? Vedant Travels offers reliable cab services for your journey to Mumbai. Whether it’s for business, sightseeing, or a personal trip, our professional drivers and comfortable vehicles will ensure that you reach Mumbai safely and on time."
    },
    {
      "name": "Thane to Airport Taxi",
      "description": "Need a taxi from Thane to the airport? Vedant Travels provides fast, convenient, and reliable taxi services for your airport commute. We ensure that you reach the airport on time and in comfort, making your travel stress-free."
    },
    {
      "name": "Thane One Way Taxi Service",
      "description": "Planning a one-way trip from Thane? Vedant Travels offers one-way taxi services at affordable rates. Whether you’re heading to Mumbai, the airport, or any other destination, our one-way taxi service provides flexibility and convenience without the need for a return journey."
    },
    {
      "name": "Thane Taxi Fare",
      "description": "At Vedant Travels, we offer competitive and transparent taxi fares for travel within Thane and beyond. Our pricing is fair, ensuring you get the best value for your money while enjoying a comfortable ride. Contact us for an accurate fare quote based on your specific trip."
    },
    {
      "name": "Thane Cab Booking",
      "description": "Booking a cab in Thane is easy with Vedant Travels. Whether you need a ride for local travel or long-distance trips, our booking process is quick and convenient. Reserve your taxi online or via phone and enjoy a seamless travel experience."
    },
    {
      "name": "Best Cab Service in Thane",
      "description": "Vedant Travels is the best choice for a cab service in Thane. We pride ourselves on our reliable, punctual, and affordable taxi services, ensuring that you enjoy a comfortable and safe ride, every time. Choose us for your transportation needs in Thane."
    },
    {
      "name": "Thane to Thane Round Trip",
      "description": "Need a round trip within Thane? Vedant Travels offers flexible round-trip taxi services, ensuring you have a comfortable and timely journey, whether you’re traveling to multiple locations or need a taxi for the entire day. Our experienced drivers will make sure you have a hassle-free experience."
    }
  ],



 "tableData": [
    ["Cab Service in Thane", "Thane Taxi Service"],
    ["Thane Car Hire", "Thane to Mumbai Cab"],
    ["Thane to Airport Taxi", "Thane One Way Taxi Service"],
    ["Thane Taxi Fare", "Thane Cab Booking"],
    ["Best Cab Service in Thane", "Thane to Thane Round Trip"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality. Whether you need a ride for a business meeting or a leisure trip, our drivers ensure timely pickups and drop-offs, making your journey in and around Thane smooth and hassle-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Our fleet of well-maintained vehicles is designed for comfort. With spacious interiors, air conditioning, and comfortable seating, we ensure a pleasant ride for both short and long-distance travel within Thane and beyond."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are professional, experienced, and well-versed with the roads in and around Thane. They ensure a smooth, safe, and efficient ride, offering great customer service and ensuring your comfort throughout the journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive and transparent pricing. You’ll know exactly what you’re paying for, with no hidden charges. Our pricing is designed to provide you the best value for your money, whether it’s a short trip within Thane or a long journey."
    },
    {
      "WhyChooseheading": "Safe and Secure Journey",
      "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to all safety protocols to ensure a secure ride for you."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you need a ride early in the morning, late at night, or anytime in between, Vedant Travels is available 24/7 to serve your travel needs. Our customer service team is always ready to assist with bookings or any queries."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your cab with Vedant Travels is quick and easy. You can book your ride online through our website or mobile app, or you can contact our customer service team for assistance."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer tailored services to suit your specific travel needs. Whether it’s a one-way trip, round trip, or hourly hire within Thane, we customize our packages to meet your preferences and schedule."
    }
  ]
    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab in Thane with Vedant Travels?',
            answer: 'You can easily book your cab online through our website or mobile app. Alternatively, you can contact our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for trips in Thane?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars. All vehicles are well-maintained, providing comfort and safety for both short and long journeys.',
        },
        {
            id: 3,
            question: 'Are the drivers experienced for local trips in Thane?',
            answer: 'Yes, our drivers are highly experienced and familiar with the roads in and around Thane. They ensure a smooth and safe ride while providing excellent customer service.',
        },
        {
            id: 4,
            question: 'How do I pay for my cab rental in Thane?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app, making the payment process easy and convenient.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab within Thane?',
            answer: 'Yes, you can book a round-trip cab within Thane. Simply provide your return details during the booking process, and we will take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting time or detours in Thane?',
            answer: 'Any additional charges for waiting or detours will be communicated to you upfront. We believe in complete transparency, so you will always be informed of any extra charges.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Thane?',
            answer: 'Yes, we offer sightseeing tours in and around Thane, covering popular attractions such as Upvan Lake, Kelva Fort, and the beautiful Yeoor Hills. Our drivers can guide you to local destinations for a relaxed trip.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a cab in Thane?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional or specialized luggage, please inform us at the time of booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel in Thane?',
            answer: 'Yes, we provide corporate travel services, including rides to business meetings, conferences, and events in and around Thane. We ensure punctual and comfortable travel for your professional needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for cab service in Thane?',
            answer: 'Vedant Travels stands out for its reliable, affordable, and comfortable service. With professional drivers, well-maintained vehicles, and transparent pricing, we ensure that your travel within Thane is smooth, stress-free, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Arvind Sharma",
            title: "Customer",
            quote: "I booked a cab for a local trip in Thane with Vedant Travels, and the experience was excellent. The vehicle was clean, and the driver was professional and punctual. I’ll definitely choose them for my future rides in Thane.",
            rating: 5,
        },
        {
            name: "Mrs. Priya Deshmukh",
            title: "Customer",
            quote: "I had a wonderful experience traveling with Vedant Travels within Thane. The cab was comfortable, and the driver was friendly and knowledgeable about the area. It was a great trip, and I will definitely use their services again.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   

  
  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Thane",
  "image": "https://vedanttravels.in/assets/images/cab-service-in-thane.jpg",
  "description": "Book reliable cab service in Thane with Vedant Travels for safe, comfortable, and affordable rides. Choose from AC sedans, SUVs, and tempo travellers for local and outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "599",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/cab-service-in-thane"
  }
};



  


    return (
        <div>
           
         <Helmet>
  <title>Cab Service in Thane | Reliable & Affordable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Thane with Vedant Travels for safe, comfortable, and affordable rides. Choose from AC sedans, SUVs, and tempo travellers for local and outstation travel." 
  />
  <meta 
    name="keywords" 
    content="Cab Service in Thane, Thane Taxi Service, Vedant Travels Thane, AC Cab Thane, SUV Cab Thane, Local Cab Thane, Outstation Cab Thane, Affordable Taxi Thane" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/96.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinthane;